var map = {
	"./1.png": 3858,
	"./2.png": 927,
	"./3.png": 178,
	"./4.png": 9032,
	"./5.png": 1535,
	"./6.png": 4619,
	"./7.png": 6920,
	"./8.png": 5517
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9365;